import Vue             from 'vue';
import Vuex            from 'vuex';
import sharedMutations from 'vuex-shared-mutations';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const persist = new VuexPersistence({
	storage : window.localStorage,
});

export default new Vuex.Store({
	state     : {
		favourites : [] as string[],
	},
	mutations : {
		favourite   : (state, mazeId: string) => {
			if (!state.favourites.includes(mazeId)) {
				state.favourites.push(mazeId);
			}
		},
		unfavourite : (state, mazeId) => {
			const index = state.favourites.findIndex(e => e === mazeId);

			if (index !== -1) {
				state.favourites.splice(index, 1);
				localStorage.setItem('favourites', JSON.stringify(state.favourites));
			}
		},
	},
	plugins   : [
		sharedMutations({ predicate: ['favourite', 'unfavourite'] }),
		persist.plugin,
	],
});
